import { Routes } from '@angular/router';
import { authGuard } from './guard/auth.guard';
import { noAuthGuard } from './guard/no-auth.guard';
import { registrationGuard } from './guard/registration.guard';
import { CanDeactivateGuard } from './guard/can-deactivate.guard';

export const routes: Routes = [
    // Login - protected by noAuthGuard (redirects authenticated users to dashboard)
    {
        path: 'login',
        loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
        canActivate: [noAuthGuard],
        data: {
            meta: {
                title: 'Login',
                navName: 'Login',
                navIcon: 'login'
            }
        }
    },
    // Registration - protected by registrationGuard (requires OTP validation)
    {
        path: 'registration',
        loadComponent: () => import('./pages/registration/registration.component').then(m => m.RegistrationComponent),
        canActivate: [registrationGuard],
        canDeactivate: [CanDeactivateGuard],
        data: {
            meta: {
                title: 'Registration',
                navName: 'Registration',
                navIcon: 'person_add'
            }
        }
    },
    // Prescription - protected by registrationGuard (requires OTP validation)
    {
        path: 'registration/prescription',
        loadComponent: () => import('./pages/registration/prescription/prescription.component').then(m => m.PrescriptionComponent),
        canActivate: [registrationGuard],
        canDeactivate: [CanDeactivateGuard],
        data: {
            meta: {
                title: 'Upload Prescription',
                navName: 'Prescription',
                navIcon: 'description'
            }
        }
    },
    // Dashboard - protected by authGuard (requires authentication)
    {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [authGuard],
        data: {
            meta: {
                title: 'Dashboard',
                navName: 'Dashboard',
                navIcon: 'dashboard'
            }
        }
    },
    // Refill request - protected by authguard
    {
        path: 'prescription',
        loadComponent: () => import('./pages/registration/prescription/prescription.component').then(m => m.PrescriptionComponent),
        canActivate: [authGuard],
        data: {
            meta: {
                title: 'Upload Prescription',
                navName: 'Prescription',
                navIcon: 'description'
            }
        }
    },
    // Requests - protected by authGuard
    {
        path: 'requests',
        loadComponent: () => import('./pages/requests/requests.component').then(m => m.RequestsComponent),
        canActivate: [authGuard],
        data: {
            meta: {
                title: 'Requests',
                navName: 'Requests',
                navIcon: 'assignment'
            }
        }
    },
    // Default route (shows on load)
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    // Not Found
    {
        path: 'not-found',
        loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
        data: {
            meta: {
                title: 'Not Found',
                navName: 'Not Found',
                navIcon: 'error'
            }
        }
    },
    // Wildcard route - redirect to not-found
    {
        path: '**',
        redirectTo: '/not-found',
        pathMatch: 'full' 
    }
];
